import Cookies from 'js-cookie'

const key = 'mobileToken'

export function getToken() {
  return Cookies.get(key)
}

export function setToken(token) {
  return Cookies.set(key, token)
}

export function setTokenExpires(token) {
  return Cookies.set(key, token, { expires: 1 });
}

export function removeToken() {
  return Cookies.remove(key)
}
